import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';
import { BsX } from 'react-icons/bs';

import styles from './index.module.scss';
import logoWhiteSrc from '../../asset/images/global/logo_white.png';

const cx = classNames.bind(styles);

const MobileGnbComponent = ({ setIsMobileGnb }) => {
  const hideMobileGnb = () => {
    setIsMobileGnb(false);
  };

  return (
    <ul className={cx('gnb')}>
      <li>
        <img src={logoWhiteSrc} alt="" />
      </li>
      <li onClick={hideMobileGnb}>
        <Link to="/">HOME</Link>
      </li>
      <li onClick={hideMobileGnb}>
        <Link to="/about">ABOUT</Link>
      </li>
      <li onClick={hideMobileGnb}>
        <Link to="/product">PRODUCT</Link>
      </li>
      {/* <li onClick={hideMobileGnb}>
        <a
          href="https://smartstore.naver.com/levrai_cosmetic/category/d587c378d7514158bb7993d168403328?cp=1"
          target="_blank"
          rel="noreferrer">
          SHOP
        </a>
      </li> */}
      <li onClick={hideMobileGnb}>
        <Link to="/about#contact">CONTACT</Link>
      </li>
      <li>
        <button type="button" onClick={hideMobileGnb}>
          <BsX />
        </button>
      </li>
    </ul>
  );
};

export default MobileGnbComponent;
